import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useNavigate } from "react-router-dom";

import { Button, Link, Td, Text, Tr, useColorModeValue, VStack } from "@chakra-ui/react";
import moment from "moment";

import { getPropertyAddress } from "../../utils/verifier";
import OwnerPopover from "../ContactPopover/OwnerPopover";

export default function ArchivedPropertiesTableRow({ row }) {
	const { t } = useTranslation();
	const textColor = useColorModeValue("gray.700", "white");
	const bgHover = useColorModeValue("gray.50", "gray.700");
	const navigate = useNavigate();
	const propertyPath = `/properties/view/${row.id}`;

	return (
		<Tr
			cursor="pointer"
			_hover={{ bg: bgHover }}
			transition="all 0.2s"
			onClick={() => navigate(propertyPath)}
		>
			<Td>
				<VStack align="start" spacing="0">
					<Text fontSize="md" color={textColor} fontWeight="bold">
						{getPropertyAddress(row)}
					</Text>
					<Text fontSize="xs" color="gray.500">
						{moment(row.addedDate).format("DD MMM YYYY - HH:mm")}
					</Text>
				</VStack>
			</Td>
			<Td onClick={(e) => e.stopPropagation()}>
				<OwnerPopover contact={row.owner} />
			</Td>
			<Td onClick={(e) => e.stopPropagation()}>
				<Link as={NavLink} to={propertyPath}>
					<Button>{t("table.view")}</Button>
				</Link>
			</Td>
		</Tr>
	);
}
